import { TCAppConfig } from "../../../../../../shared/app-configs/tc-app-configs";
import { useTransactionCertificateStore } from "../../../../../../store/transaction-certificates.store";
import {  MappedComponentPayload } from "./component-details.model";

export async function fetchaddComponentDetails(
  executeGet: (url: string, params: Record<string, any>) => Promise<any>,
  tcId: string,
  shipmentId: string,
  productId: string,
  componentId: string
): Promise<any> {
  if (!componentId) return null;
  try {
    const response = await executeGet(TCAppConfig.GET_COMPONENT_DETAIL_V4, {
      tcId,
      // shipmentId,
      productId,
      componentId,
    });
    return response;
  } catch (err) {
    console.error("Error fetching component details:", err);
    throw new Error("Failed to load component details.");
  }
}

/**
 * Maps the ApiComponentData into the desired payload structure.
 *
 * @param data - The input data from the API.
 * @param tcId - The tcId value to set on the payload.
 * @param productId - The productId for the component.
 * @param componentId - Optional componentId (only for edit or same component scenarios).
 * @returns The mapped payload.
 */
export const mapComponentData = (
  data: any,
  tcId: string,
  productId: string,
  componentId?: string | null
): MappedComponentPayload => {
  return {
    tcId,
    productId, //  always required for all scenarios
    ...(componentId ? { componentId } : {}), //  include only when applicable
    tcProductComponentInformation: [
      {
        tcAssociatedProductArticleNo: data.componentInfo.tcAssociatedProductNo ?? "",
        tcProductComponentNo: data.componentInfo.tcProductComponentNo ?? "", 
        tcProductComponentDetail: data.componentInfo.tcProductComponentDetail ?? "",
        tcProductComponentInfoFiberLength: data.componentInfo.tcProductComponentInfoFiberLength ?? "",
        tcProductComponentInfoYarnCount: data.componentInfo.tcProductComponentInfoYarnCount ?? "",
        tcProductComponentInfoFabricWeightAndConstruct:
          data.componentInfo.tcProductComponentInfoFabricWeightAndConstruct ?? "",
        tcProductComponentInfoFabricWeightOfFinishedProduct:
          data.componentInfo.tcProductComponentInfoFabricWeightOfFinishedProduct ?? "",
        tcProductComponentNetShippingWeight: data.componentInfo.tcProductComponentNetShippingWeight ?? null,
        tcProductComponentInfoAdditional: data.componentInfo.tcProductComponentInfoAdditional ?? "",
        tcProductComponentInfoTechnicalSpecifications:
          data.componentInfo.tcProductComponentInfoTechnicalSpecifications ?? "",
        tcProductComponentCertifiedWeightInformation: (data.standardInfo || []).map((item: any) => ({
          tcProductComponentClaimsCategory: item.tcProductComponentClaimsCategory ?? "",
          tcProductComponentClaimsCategoryDescription:
            item.tcProductComponentClaimsCategoryDescription ?? "",
          tcProductComponentCertifiedWeight: item.tcProductComponentCertifiedWeight ?? null,
        })),
        tcProductComponentRawMaterialInformation: (data.rawMaterialInfo || []).map((item: any) => ({
          tcProductComponentRawMaterialCode: item.tcProductComponentRawMaterialCode ?? "",
          tcProductComponentRawMaterialCodeDescription:
            item.tcProductComponentRawMaterialCodeDescription ?? "",
          tcProductComponentRawMaterialPercentage: item.tcProductComponentRawMaterialPercentage ?? null,
        })),
      },
    ],
  };
};
